"use client";

import styles from "./ConfirmResetPasswordForm.module.scss";

import { useForm } from "@/hooks";
import { withLocale } from "@/helpers";
import { useLocale, useTranslations } from "@/i18n";

import {
  ResetPasswordConfirmPasswordInput,
  ResetPasswordNewPasswordInput,
  ResetPasswordSubmitButton,
} from "..";
import {
  Button,
  Flex,
} from "@vetty/ui";

/**
 * ConfirmResetPasswordForm Component
 *
 * Form component for confirming a new password reset.
 * Handles password input, confirmation, and submission.
 * Displays success state after password reset.
 */
export const ConfirmResetPasswordForm = () => {
  const t = useTranslations("resetPassword.success");
  const locale = useLocale();

  const { values } = useForm();

  return (
    <Flex direction={"column"} className={styles["comp"]}>
      <Flex direction={"column"} className={styles["comp__content"]}>
        {/* Form state - show input fields when not submitted */}
        {!values.status && (
          <Flex direction={"column"} gap={40} className={styles["comp__form"]}>
            <Flex direction={"column"} gap={24}>
              {/* New password input */}
              <ResetPasswordNewPasswordInput />

              {/* Confirm password input */}
              <ResetPasswordConfirmPasswordInput />

              {/* Submit button */}
              <ResetPasswordSubmitButton />
            </Flex>
          </Flex>
        )}

        {/* Success state - show confirmation when password is reset */}
        {values.status && (
          <div className={styles["comp__success"]}>
            {/* Success checkmark icon */}
            <div className={styles["comp__success__icon"]}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.75004 13.9999L12.25 17.4999L19.25 10.4999M25.6667 13.9999C25.6667 20.4432 20.4434 25.6666 14 25.6666C7.55672 25.6666 2.33337 20.4432 2.33337 13.9999C2.33337 7.5566 7.55672 2.33325 14 2.33325C20.4434 2.33325 25.6667 7.5566 25.6667 13.9999Z"
                  stroke="#39AB3F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {/* Success message */}
            <div className={styles["comp__success__description"]}>
              {t("description")}
            </div>

            <Button
              className={styles["comp__success__button"]}
              href={withLocale(locale, "/login")}
            >
              {t("goToLogin")}
            </Button>
          </div>
        )}
      </Flex>
    </Flex>
  );
};
